import { Box, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LineBaseChart from "../../../Components/Charts/LineBaseChart";
import Selector from "../../../Components/Selectors/Selector";
import api from "../../../conf/api";
import PeopleIcon from "@mui/icons-material/People";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const InfoBox = ({ title, count, Icon, color = "primary" }) => (
  <Paper
    variant="outlined"
    component="section"
    aria-label={title}
    sx={{
      borderRadius: 2,
      p: { xs: 1.5, md: 2.5 },
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      minWidth: 0,
      transition: "border-color 200ms, box-shadow 200ms",
      "&:hover": { borderColor: `${color}.main` },
      "@media (prefers-reduced-motion: reduce)": { transition: "none" },
    }}
  >
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: 1.5,
        display: "grid",
        placeItems: "center",
        bgcolor: `${color}.main`,
        color: `${color}.contrastText`,
      }}
    >
      <Icon aria-hidden="true" fontSize="small" />
    </Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary" noWrap>
        {title}
      </Typography>
      <Typography
        component="p"
        fontWeight={600}
        sx={{ fontSize: { xs: "1.4rem", md: "1.75rem" }, lineHeight: 1.2, wordBreak: "break-word" }}
      >
        {count}
      </Typography>
    </Box>
  </Paper>
);

const ChartCard = ({ title, onRange, children }) => (
  <Paper variant="outlined" sx={{ borderRadius: 2, p: { xs: 2, md: 3 }, height: "100%", minWidth: 0 }}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        justifyContent: "space-between",
        gap: 1.5,
        mb: 2,
      }}
    >
      <Typography variant="h6" component="h2" fontWeight={600}>
        {title}
      </Typography>
      <Box sx={{ maxWidth: "100%", overflowX: "auto" }}>
        <Selector setDateRange={onRange} />
      </Box>
    </Box>
    <Box sx={{ width: "100%", minWidth: 0, overflowX: "auto" }}>{children}</Box>
  </Paper>
);

function InformationPannel(props) {
  const initialMetaFields = {
    uploaded: 0,
    videos: 0,
    users: 0,
    creators: 0,
    nonactive_creators: 0,
  };
  const [meta, setMeta] = useState(initialMetaFields);
  const initialChartField = {
    videoHits: { loading: false, date: { start: null, end: null }, data: [] },
    earningHits: { loading: false, date: { start: null, end: null }, data: [] },
    upcomingPayments: { loading: false, date: { start: null, end: null }, data: [] },
  };
  const [chartData, setChartData] = useState(initialChartField);

  async function getVideoCounts(startDate = null, endDate = null) {
    try {
      setChartData((prevData) => ({
        ...prevData,
        videoHits: { ...prevData.videoHits, loading: true, data: [] },
      }));
      let _params;
      if (endDate) {
        _params = { start: startDate, end: endDate }
      }

      const video_res = await api.get("/videos/videohits/", { params: _params });
      const video_data = video_res.data;
      setChartData((prevData) => ({
        ...prevData,
        videoHits: { ...prevData.videoHits, loading: false, data: video_data },
      }));
    } catch {

    }
  }
  async function getLifeTimeEarning(startDate = null, endDate = null) {
    try {


      setChartData((prevData) => ({
        ...prevData,
        earningHits: { ...prevData.earningHits, loading: true, data: [] },
      }));
      let _params;
      if (endDate) {
        _params = { start: startDate, end: endDate }
      }

      const earning_res = await api.get("/earning/hits/", { params: _params });
      const earning_data = earning_res.data?.lifetimeEarning;

      setChartData((prevData) => ({
        ...prevData,
        earningHits: { ...prevData.earningHits, loading: true, data: earning_data },
      }));
    }
    catch { }
  }
  async function getUpcomingPayments(startDate = null, endDate = null) {
    try {


      setChartData((prevData) => ({
        ...prevData,
        videoHits: { ...prevData.upcomingPayments, loading: true, data: [] },
      }));
      let _params;

      if (endDate) {
        _params = { start: startDate, end: endDate }
      }

      const payment_res = await api.get("/earning/hits/", { params: _params });
      const payment_data = payment_res.data?.upcomingPayments;

      setChartData((prevData) => ({
        ...prevData,
        upcomingPayments: { ...prevData.upcomingPayments, loading: false, data: payment_data },
      }));
    }
    catch { }
  }


  useEffect(() => {
    async function GetMeta() {
      await api
        .get("/videos/getcounts")
        .then((res) => {
          setMeta(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
      if (props.user?.is_staff) {
        await api
          .get("/users/count/")
          .then((res) => {
            if (res.status === 200) {
              setMeta((pre) => ({ ...pre, ...res.data }));
            }
          })
          .catch((resp) => {
            const errorObject = resp.response?.data;
            try {
              for (const field in errorObject) {
                if (errorObject?.hasOwnProperty(field)) {
                  const errors = errorObject[field];
                  const formattedFieldErrors = errors.map(
                    (errorMessage) => `${field}:${errorMessage}`
                  );
                  formattedFieldErrors?.map((msg) => toast.error(msg));
                }
              }
            } catch {
              try {
                toast.error(JSON.stringify(errorObject));
              } catch {
                toast.error("Something went wrong");
              }
            }
          });
      }
    }
    GetMeta();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getVideoCounts(chartData.videoHits?.date?.start, chartData.videoHits?.date?.end)
    // eslint-disable-next-line
  }, [chartData.videoHits.date.start])
  useEffect(() => {
    getLifeTimeEarning(chartData.earningHits?.date?.start, chartData.earningHits?.date?.end)
    // eslint-disable-next-line
  }, [chartData.earningHits.date.start])
  useEffect(() => {
    getUpcomingPayments(chartData.upcomingPayments?.date?.start, chartData.upcomingPayments?.date?.end)
    // eslint-disable-next-line
  }, [chartData.upcomingPayments.date.start])

  const setRange = (key) => (start, end) => {
    setChartData((pre) => ({
      ...pre,
      [key]: { ...pre[key], date: { start: start, end: end } },
    }));
  };
  const kpiSx = { display: "grid", gap: { xs: 1.5, md: 2 }, gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))", lg: "repeat(4, minmax(0, 1fr))" } };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: "auto", width: "100%" }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" fontWeight={600} sx={{ fontSize: { xs: "1.5rem", md: "2.125rem" } }}>
          Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Overview of your videos, earnings and upcoming payments.
        </Typography>
      </Box>

      <Box sx={kpiSx}>
        <InfoBox title="Videos" count={meta.videos || 0} Icon={SlowMotionVideoIcon} color="primary" />
        <InfoBox title="Uploaded" count={meta.uploaded || 0} Icon={CloudDoneIcon} color="info" />
        <InfoBox title="Lifetime Earnings" count={`$ ${meta.lifeTime || 0}`} Icon={AttachMoneyIcon} color="success" />
        <InfoBox title="Upcoming Payments" count={`$ ${meta.upcoming || 0}`} Icon={AttachMoneyIcon} color="warning" />
        {props.user?.is_staff && (
          <>
            <InfoBox title="Total users" count={meta.users || 0} Icon={PeopleIcon} color="primary" />
            <InfoBox title="Creators" count={meta.creators || 0} Icon={MotionPhotosAutoIcon} color="success" />
            <InfoBox title="Non active" count={meta.nonactive_creators || 0} Icon={HourglassBottomIcon} color="error" />
            <InfoBox title="Ingested Assets" count={meta.assets_sheet || 0} Icon={HourglassBottomIcon} color="secondary" />
          </>
        )}
      </Box>

      <Box sx={{ display: "grid", gap: { xs: 2, md: 3 }, mt: 3, gridTemplateColumns: { xs: "minmax(0, 1fr)", lg: "repeat(2, minmax(0, 1fr))" } }}>
        <Box sx={{ gridColumn: { lg: "1 / -1" }, minWidth: 0 }}>
          <ChartCard title="Videos" onRange={setRange("videoHits")}>
            <LineBaseChart data={chartData.videoHits?.data} yDatakey={"video_count"} xDatakey={"date"} />
          </ChartCard>
        </Box>
        <ChartCard title="Lifetime Earnings" onRange={setRange("earningHits")}>
          <LineBaseChart data={chartData.earningHits?.data || 0} yDatakey={"amount"} xDatakey={"date"} />
        </ChartCard>
        <ChartCard title="Upcoming Payments" onRange={setRange("upcomingPayments")}>
          <LineBaseChart data={chartData.upcomingPayments?.data} yDatakey={"amount"} xDatakey={"date"} />
        </ChartCard>
      </Box>
    </Box>
  );
}
const mapStatesToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStatesToProps, null)(InformationPannel);
